import { getLocalizedPath } from '../i18n/routes'
import { useLocation } from 'react-router-dom'
import { useRouteMetadata } from '../components/inventory/useRouteMetadata'
import { useI18n } from '../i18n/I18nProvider'
import type { UiMessageKey } from '../i18n/ui'
import { Link } from '../ui/Link'

export function RoutePlaceholder({ titleKey }: { titleKey: UiMessageKey }) {
  const { language, t } = useI18n()
  const { pathname } = useLocation()
  useRouteMetadata({
    title: t('seo.placeholderMetadataTitle'),
    description: t('seo.placeholderMetadataDescription'),
    pathname,
    language,
  })
  return (
    <section className="route-placeholder">
      <div className="page-frame route-placeholder__inner">
        <p className="section-kicker">{t('common.notAvailable')}</p>
        <h1 tabIndex={-1}>{t(titleKey)}</h1>
        <p>{t('sandbox.routePlaceholder')}</p>
        <Link variant="secondary" to={getLocalizedPath('home', language)}>
          {t('sandbox.backToFoundation')}
        </Link>
      </div>
    </section>
  )
}
